
import { computed, defineComponent, ref } from 'vue'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import variables from '@/styles/_variables.scss'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: {
    SidebarItem,
    SidebarLogo
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    const routes = computed(() => {
      return store.state.permission.routes
    })
    const showLogo = computed(() => {
      return store.state.settings.showSidebarLogo
    })

    const menuActiveTextColor = computed(() => {
      if (store.state.settings.sidebarTextTheme) {
        return '#57CAEB'
        // return store.state.settings.theme
      } else {
        return variables.menuActiveText
      }
    })

    const activeMenu = computed(() => {
      const { meta, path } = route
      if (meta !== null || meta !== undefined) {
        if (meta.activeMenu) {
          return meta.activeMenu
        }
      }
      return path
    })

    const isCollapse = computed(() => {
      return sidebar.value.opened
    })

    const menus = ref([
      {
        title: 'LPOA  /  IPI',
        path: '/lpoa',
        icon: 'lpoa',
        children: [
          {
            title: '实时数据',
            path: '/lpoa/realTimeData'
          },
          {
            title: '账户管理',
            path: '/lpoa/accountManager'
          },
          {
            title: '批量交易',
            path: '/lpoa/bulkTrading'
          },
          {
            title: '分仓交易记录',
            path: '/lpoa/splitOrder'
          },
          {
            title: '柜台交易记录',
            path: '/lpoa/otc'
          }
        ]
      },
      {
        title: '货币兑换',
        path: '/currency',
        icon: 'currency-icon',
        children: [
          {
            title: '兑入/兑出',
            path: '/currency/exchange'
          },
          {
            title: '兑换记录',
            path: '/currency/record'
          }
        ]
      },
      {
        title: '账户委托',
        path: '/accountEntrust',
        icon: 'accountEntrust-icon',
        children: [
          {
            title: '委托记录',
            path: '/accountEntrust/entrustRecord'
          }
        ]
      }
    ])

    return {
      sidebar,
      routes,
      showLogo,
      menuActiveTextColor,
      variables,
      activeMenu,
      isCollapse,
      menus
    }
  }
})
